import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { AbilityServiceSignal } from '@casl/angular';
import { TranslateModule } from '@ngx-translate/core';
import { AuthorizationModule } from '@wilson/authorization';
import { FeatureFlagsModule } from '@wilson/feature-flags';
import {
  FeatureName,
  RoleAction,
  RolePermissionSubject,
} from '@wilson/interfaces';
import {
  CollapsibleActivitiesListComponent,
  CollapsibleShiftNoteComponent,
  CollapsibleShiftReportsAttachmentsComponent,
  CollapsibleShiftWageDataComponent,
  IsShiftAcceptedPipe,
  IsShiftSubmittedOrAcceptedPipe,
} from '@wilson/non-domain-specific/shift-helpers/core';
import { PayrollTransactionsComponent } from '@wilson/payroll/shared';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { SimplifiedDrawerShift } from '../types';
import { ViolationCommentComponent } from './violation-comment/violation-comment.component';
import {
  ClientCommentsSectionComponent,
  ShiftClientCommentsFeatureService,
} from '@wilson/non-domain-specific/shift-client-comments';

@Component({
  selector: 'wilson-shift-reported-section',
  templateUrl: './reported-section.component.html',
  styleUrl: './reported-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    AuthorizationModule,
    FeatureFlagsModule,
    NzCollapseModule,
    CollapsibleActivitiesListComponent,
    CollapsibleShiftReportsAttachmentsComponent,
    CollapsibleShiftWageDataComponent,
    CollapsibleShiftNoteComponent,
    PayrollTransactionsComponent,
    ViolationCommentComponent,
    IsShiftAcceptedPipe,
    IsShiftSubmittedOrAcceptedPipe,
    ClientCommentsSectionComponent,
  ],
})
export class ReportedSectionComponent {
  readonly shift = input.required<SimplifiedDrawerShift>();
  readonly isExpandedOnOpen = input(true);
  readonly refresh = output<void>();

  protected readonly can = inject(AbilityServiceSignal).can;

  protected readonly shiftClientCommentsFeature = inject(
    ShiftClientCommentsFeatureService,
  );
  protected readonly RoleAction = RoleAction;
  protected readonly RolePermissionSubject = RolePermissionSubject;
  protected readonly FeatureName = FeatureName;
}
